import z from "zod";
import { getProjectSchema } from "../../project/api/get-project.schema";

export const getMeasurementSchema = z
	.object({
		ticketAssignmentId: z.uuid(),
	})
	.and(getProjectSchema);

export type GetMeasurementSchema = z.infer<typeof getMeasurementSchema>;
